export const OPPGAVE_RETUR_URL_TEKST = "Oppgave";
export const OPPGAVER_PATH = "/oppgaver";
export const FULLMAKT_PATH = "/fullmakt";
